import { MdMenu } from 'react-icons/md';
import Button from '../../atoms/Button';
import { useAppShell } from './AppShellContext';
import { APP_SHELL_TOGGLE_ATTRIBUTE } from './appShellConstants';

/** Кнопка меню в шапке (бургер): ось совпадает с осью иконок рейла (12 + 40 / 2 = 32 px). */
export const AppShellMenuToggle = () => {
    const { toggleSidebar, sidebarToggleLabel, sidebarOpen } = useAppShell();
    return (
        <div className="header-navbar__burger-menu" {...{ [APP_SHELL_TOGGLE_ATTRIBUTE]: '' }}>
            <Button
                variant="header-ghost"
                size="md"
                onClick={toggleSidebar}
                className="menu-toggle-button"
                data-testid="header-sidebar-toggle"
                aria-label={sidebarToggleLabel}
                aria-expanded={sidebarOpen}
                startAdornment={<MdMenu size="24" />}
            />
        </div>
    );
};
